export default {
    toAddBoardBegin(state) {
      state.loading = true;
    },
  
    toAddBoardSuccess(state, data) {
      state.loading = false;
      state.boardData = data;
    },
  
    toAddBoardErr(state, err) {
      state.loading = false;
      state.error = err;
    },
    toAddTaskBegin(state) {
      state.tsLoading = true;
    },
  
    toAddTaskSuccess(state, data) {
      state.tsLoading = false;
      state.taskData = data;
    },
  
    toAddTaskErr(state, err) {
      state.tsLoading = false;
      state.error = err;
    },
  
    toDeleteTaskBegin(state) {
      state.tsLoading = true;
    },
  
    toDeleteTaskSuccess(state, data) {
      state.tsLoading = false;
      state.taskData = data;
    },
  
    toDeleteTaskErr(state, err) {
      state.tsLoading = false;
      state.error = err;
    },

    labelReadAllBegin(state) {
        state.loading = true;
    },

    labelReadAllSuccess(state, data) {
        state.loading = false;
        const boardData = [];
        const taskData = [];
        data.forEach((item) => {
            boardData.push({
                boardId: item.id.toString(),
                title: item.name,
                // El color viaja AHORA con el dato. Antes salia de
                // src/constant/labels.js buscando por un id fijo del 1 al 9;
                // con las etapas propias de cada cliente esos ids ya no
                // existen, la busqueda devolvia undefined y la bolita se
                // quedaba sin color. Ademas, asi una etapa que el cliente
                // crea puede tener su propio color.
                color: item.color || null,
                isEntry: !!item.isEntry,
            });

            // iterate over tasks in item.tasks
            item.contacts.forEach((contact) => {
                taskData.push({
                    id: contact.id.toString(),
                    boardId: contact.tagId.toString(),
                    title: `${contact.firstName} ${contact.lastName}`,
                    contact: contact,
                });
            });
        });

        state.boardData = boardData;
        state.taskData = taskData;
    },

    labelContactUpdateBegin(state) {
        state.loading = true;
    },

    labelContactUpdateSuccess(state, data) {
        state.loading = false;
        // find the task in taskData and update the new labelId
        const taskIndex = state.taskData.findIndex((task) => task.id === data.id.toString());
        state.taskData[taskIndex].boardId = data.labelId.toString();
        //state.taskData[taskIndex].contact.tagId = data.labelId;
    },

    labelContactUpdateErr(state, err) {
        state.loading = false;
        state.error = err;
    },

    labelReadAllErr(state, err) {
        state.loading = false;
        state.error = err;
    },

  };